/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskPolicyModelConfig = {
  /**
   * When the judge errors or times out: true allows the message (fail-open), false blocks it (fail-closed). Defaults to fail-open.
   */
  failOpen?: boolean | undefined;
  /**
   * Sampling temperature for the judge. Defaults to a low value for deterministic verdicts.
   */
  temperature?: number | undefined;
};

/** @internal */
export const RiskPolicyModelConfig$inboundSchema: z.ZodMiniType<
  RiskPolicyModelConfig,
  unknown
> = z.pipe(
  z.object({
    fail_open: z.optional(z.boolean()),
    temperature: z.optional(z.number()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "fail_open": "failOpen",
    });
  }),
);
/** @internal */
export type RiskPolicyModelConfig$Outbound = {
  fail_open?: boolean | undefined;
  temperature?: number | undefined;
};

/** @internal */
export const RiskPolicyModelConfig$outboundSchema: z.ZodMiniType<
  RiskPolicyModelConfig$Outbound,
  RiskPolicyModelConfig
> = z.pipe(
  z.object({
    failOpen: z.optional(z.boolean()),
    temperature: z.optional(z.number()),
  }),
  z.transform((v) => {
    return remap$(v, {
      failOpen: "fail_open",
    });
  }),
);

export function riskPolicyModelConfigToJSON(
  riskPolicyModelConfig: RiskPolicyModelConfig,
): string {
  return JSON.stringify(
    RiskPolicyModelConfig$outboundSchema.parse(riskPolicyModelConfig),
  );
}
export function riskPolicyModelConfigFromJSON(
  jsonString: string,
): SafeParseResult<RiskPolicyModelConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPolicyModelConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPolicyModelConfig' from JSON`,
  );
}
